<script>
  import tiposAceitos from '~js/tipos-arquivos-upload';
  import AnexosOutrosLocaisModal from './AnexosOutrosLocaisModal.vue';

  export default {
    components: { AnexosOutrosLocaisModal },
    props: {
      value: { type: Array, default: () => [] },
      titulo: { type: String, default: 'Arquivos' },
      dica: { type: String, default: '' },
      limite: { type: Number, default: 0 },
      origens: { type: Object, default: null },
    },
    data() {
      return { outrosLocais: false }
    },
    computed: {
      arquivos() { return this.value || []; },
      limiteTexto() {
        if (!(this.limite > 0)) return '';
        return (this.limite / 1024 / 1024).toFixed(2).replace('.', ',') + ' MB por arquivo';
      },
    },
    methods: {
      abrirSeletor() { this.$refs.entrada.click(); },
      incluirOutrosLocais(escolhidos) {
        const lista = this.arquivos.slice();

        (escolhidos || []).forEach(e => {
          if (lista.some(a => a.referencia && a.origem === e.origem && a.id === e.id && a.nome === e.nome)) return;
          lista.push(e);
        });

        this.outrosLocais = false;
        this.$emit('input', lista);
      },
      tamanho(bytes) {
        const kb = (+bytes || 0) / 1024;
        if (kb < 1024) return Math.max(1, Math.round(kb)) + ' KB';
        return (kb / 1024).toFixed(1).replace('.', ',') + ' MB';
      },
      tipoValido(arquivo) {
        if (tiposAceitos.indexOf(arquivo.type) >= 0) return true;
        return /\.(pdf|png|jpg|jpeg|gif|bmp|txt|xml|doc|docx|xls|xlsx|ods|csv)$/i.test(arquivo.name || '');
      },
      selecionar(evento) {
        const escolhidos = Array.prototype.slice.call(evento.target.files || []);
        const lista = this.arquivos.slice();

        escolhidos.forEach(arquivo => {
          if (!this.tipoValido(arquivo)) {
            toastr.warning('O envio do arquivo ' + arquivo.name + ' não é permitido.');
            return;
          }

          if (this.limite > 0 && arquivo.size > this.limite) {
            toastr.warning('O arquivo ' + arquivo.name + ' passa de ' + this.limiteTexto + '.');
            return;
          }

          if (lista.some(a => a.name === arquivo.name && a.size === arquivo.size)) return;

          lista.push(arquivo);
        });

        this.$refs.entrada.value = null;
        this.$emit('input', lista);
      },
      remover(indice) {
        const lista = this.arquivos.slice();
        lista.splice(indice, 1);
        this.$emit('input', lista);
      },
    },
    template: `
      <div class="anx">
        <div class="anx-cab">
          <span class="anx-tit"><i class="fa fa-paperclip"></i> {{ titulo }}</span>
          <span v-if="arquivos.length" class="anx-cont">{{ arquivos.length }} arquivo{{ arquivos.length > 1 ? 's' : '' }}</span>
          <button type="button" class="anx-add" @click="abrirSeletor"><i class="fa fa-plus"></i> Escolher arquivos</button>
          <button v-if="origens" type="button" class="anx-add anx-outros" @click="outrosLocais = true"><i class="fa fa-folder-open-o"></i> De outros locais</button>
        </div>

        <div v-if="!arquivos.length" class="anx-vazio">{{ dica || 'Nenhum arquivo escolhido. Os arquivos sobem junto com a gravação.' }}</div>

        <ul v-else class="anx-lista">
          <li v-for="(a, i) in arquivos" :key="a.name + '-' + a.size + '-' + i">
            <i class="fa" :class="a.referencia ? 'fa-link' : 'fa-file-o'"></i>
            <span class="anx-nome" :title="a.referencia ? a.nome : a.name">{{ a.name }}</span>
            <span v-if="a.referencia" class="anx-ref">{{ a.rotulo }}</span>
            <span v-else class="anx-tam">{{ tamanho(a.size) }}</span>
            <button type="button" class="anx-rem" title="Remover" @click="remover(i)"><i class="fa fa-times"></i></button>
          </li>
        </ul>

        <input ref="entrada" type="file" multiple class="anx-oculto" @change="selecionar">

        <anexos-outros-locais-modal v-if="outrosLocais" :escolhidos="arquivos"
                                    :id-extrato="+origens.idExtrato || 0" :id-lancamento="+origens.idLancamento || 0"
                                    :com-contas-receber="!!origens.comContasReceber"
                                    :com-busca-contas-receber="!!origens.comBuscaContasReceber"
                                    :com-outros-extratos="!!origens.comOutrosExtratos"
                                    :id-pessoa="+origens.idPessoa || 0" :nome-pessoa="origens.nomePessoa || ''"
                                    :ids-conta-receber="origens.idsContaReceber || []"
                                    :id-conta-sugerida="+origens.idContaSugerida || 0" :nome-conta-sugerida="origens.nomeContaSugerida || ''"
                                    @escolher="incluirOutrosLocais" @fechar="outrosLocais = false"></anexos-outros-locais-modal>
      </div>`,
  }
</script>

<style scoped>
  .anx { border: 1px dashed #d4dae1; border-radius: 6px; padding: 9px 11px; background: #fcfdfd; }
  .anx-cab { display: flex; align-items: center; gap: 9px; }
  .anx-tit { font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: .05em; color: #7b848e; }
  .anx-tit .fa { color: #9aa3ac; }
  .anx-cont { font-size: 11px; color: #0a6d4d; background: #e3f3ec; border-radius: 9px; padding: 2px 8px; font-weight: 600; }
  .anx-add { margin-left: auto; height: 27px; padding: 0 11px; background: #fff; border: 1px solid #c6ccd4; border-radius: 5px; font-size: 12px; color: #3b444d; }
  .anx-add:hover { background: #f4f6f8; }
  .anx-add .fa { font-size: 10px; color: #6b747e; }
  .anx-outros { margin-left: 0; }
  .anx-ref { flex: none; max-width: 45%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 11px; color: #2b6cb0; background: #eef4fb; border-radius: 9px; padding: 1px 8px; }
  .anx-lista .fa-link { color: #2b6cb0; }
  .anx-vazio { margin-top: 7px; font-size: 11.5px; color: #9aa3ac; line-height: 1.45; }
  .anx-lista { list-style: none; margin: 8px 0 0; padding: 0; }
  .anx-lista li { display: flex; align-items: center; gap: 8px; padding: 5px 7px; background: #fff; border: 1px solid #e6e9ed; border-radius: 5px; margin-bottom: 5px; font-size: 12.5px; color: #3b444d; }
  .anx-lista li:last-child { margin-bottom: 0; }
  .anx-lista .fa-file-o { color: #9aa3ac; }
  .anx-nome { flex: 1 1 auto; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .anx-tam { flex: none; font-size: 11px; color: #9aa3ac; font-family: 'IBM Plex Mono', Consolas, monospace; }
  .anx-rem { flex: none; width: 22px; height: 22px; border: none; background: transparent; color: #b6bdc5; border-radius: 4px; }
  .anx-rem:hover { background: #fbeceb; color: #a13c3c; }
  .anx-oculto { display: none; }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/conciliacao-projeto/componentes/AnexosOperacao.vue